
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { GroupType, GroupPayloadType } from "@/common/types/group";

export async function groupList(
    platform_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `platform/${platform_id}/group/list${queryString}`
    );
}

export async function groupGet(
    group_id: string
) {
    return await clientAxios.get(
        `platform/group/${group_id}/show`
    );
}

export async function groupAdd(
    platform_id: string,
    payload: GroupPayloadType
) {
    return await clientAxios.post(
        `platform/${platform_id}/group/create`,
        payload
    );
}

export async function groupPatch(
    group_id: string,
    payload: Partial<GroupType>
) {
    return await clientAxios.patch(
        `platform/group/${group_id}/patch`,
        { payload }
    );
}

export async function groupDel(
    group_id: string,
) {
    return await clientAxios.del(
        `platform/group/${group_id}/delete`,
    );
}
